module.exports = __webpack_public_path__ + "img/7c759504-5df7-4eca-a010-33e51f64a8b0.87498177.svg";